var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#D1FADF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#ECFDF3",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0002 29C26.4297 29.5741 26.9776 30.0491 27.6067 30.3929C28.2359 30.7367 28.9317 30.9411 29.6468 30.9923C30.362 31.0435 31.0798 30.9403 31.7515 30.6897C32.4233 30.4392 33.0333 30.047 33.5402 29.54L36.5402 26.54C37.451 25.597 37.955 24.3339 37.9436 23.023C37.9322 21.712 37.4063 20.4579 36.4793 19.5309C35.5523 18.6038 34.2982 18.078 32.9872 18.0666C31.6762 18.0552 30.4132 18.5592 29.4702 19.47L27.7502 21.18M30.0002 27C29.5707 26.4258 29.0228 25.9508 28.3936 25.607C27.7645 25.2633 27.0687 25.0588 26.3535 25.0076C25.6384 24.9564 24.9206 25.0596 24.2489 25.3102C23.5771 25.5608 22.9671 25.9529 22.4602 26.46L19.4602 29.46C18.5494 30.403 18.0454 31.666 18.0568 32.977C18.0682 34.288 18.5941 35.542 19.5211 36.4691C20.4481 37.3961 21.7022 37.9219 23.0132 37.9333C24.3242 37.9447 25.5872 37.4408 26.5302 36.53L28.2402 34.82",
    stroke: "#039855",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.6cac42548945a4bad0807ad15455c636.svg";
export { ForwardRef as ReactComponent };